import React from 'react';
import styles from './toolbar.module.css';
import { SmartSelect } from '../dropdown';

interface ToolbarSelectOption {
  value: string;
  label: string;
}

interface ToolbarSelectProps {
  value: string;
  onChange: (value: string) => void;
  options: ToolbarSelectOption[];
  /** Floating label inside the field, e.g. "Method". */
  label?: string;
}

/**
 * Compact bar select — renders the unified SmartSelect (floating label, custom
 * dropdown), sized to the toolbar. An empty-string `value` is treated as the
 * "any/all" option, so it's passed through rather than coerced to null.
 */
export const ToolbarSelect: React.FC<ToolbarSelectProps> = ({
  value,
  onChange,
  options,
  label,
}) => (
  <div className={styles.selectFieldWrap}>
    <SmartSelect
      label={label ?? ''}
      value={value}
      options={options}
      onChange={(v) => onChange(v ?? '')}
    />
  </div>
);
